/* =====================================================================
   Gallery lightbox — 1776 Atelier
   Self-contained. Reads the existing .gal-stage / .gal-slide gallery,
   opens a full-screen viewer, click-to-magnify, move-to-travel, keyboard
   + touch, and syncs the underlying gallery on close. No dependencies.
   ===================================================================== */
(function () {
  var stage = document.getElementById('gal-stage');
  if (!stage) return;
  var slides = Array.prototype.slice.call(stage.querySelectorAll('.gal-slide'));
  var slideImgs = slides.map(function (s) { return s.querySelector('img'); }).filter(Boolean);
  if (!slideImgs.length) return;
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('.gal-thumb'));

  var items = slideImgs.map(function (im) {
    return { src: im.getAttribute('src'), alt: im.getAttribute('alt') || '' };
  });
  var N = items.length;
  var ZOOM = 2.5;

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function clamp01(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }

  /* ---- build the overlay once ---- */
  var lb = document.createElement('div');
  lb.className = 'lb';
  lb.setAttribute('role', 'dialog');
  lb.setAttribute('aria-modal', 'true');
  lb.setAttribute('aria-label', 'Gallery image viewer');
  lb.innerHTML =
    '<button class="lb-btn lb-close" type="button" aria-label="Close viewer">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
    '</button>' +
    '<button class="lb-btn lb-arrow lb-arrow--prev" type="button" aria-label="Previous image">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>' +
    '</button>' +
    '<button class="lb-btn lb-arrow lb-arrow--next" type="button" aria-label="Next image">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>' +
    '</button>' +
    '<div class="lb-stage"><img class="lb-img" alt="" draggable="false" /></div>' +
    '<div class="lb-count" aria-hidden="true"></div>';
  document.body.appendChild(lb);

  var lbStage = lb.querySelector('.lb-stage');
  var img = lb.querySelector('.lb-img');
  var count = lb.querySelector('.lb-count');
  var closeBtn = lb.querySelector('.lb-close');
  var prevBtn = lb.querySelector('.lb-arrow--prev');
  var nextBtn = lb.querySelector('.lb-arrow--next');

  var idx = 0, open = false, zoomed = false;
  var fitRect = null, down = false, dragged = false, downX = 0, downY = 0;

  function measureFit() { if (!zoomed) fitRect = img.getBoundingClientRect(); }

  function frac(cx, cy) {
    if (!fitRect) measureFit();
    if (!fitRect || !fitRect.width) return { x: 0.5, y: 0.5 };
    return { x: clamp01((cx - fitRect.left) / fitRect.width), y: clamp01((cy - fitRect.top) / fitRect.height) };
  }

  function zoomOut() {
    zoomed = false;
    img.classList.remove('is-zoomed');
    img.style.transform = '';
    img.style.transformOrigin = 'center center';
  }
  function zoomInAt(cx, cy) {
    measureFit();
    var f = frac(cx, cy);
    img.style.transformOrigin = (f.x * 100) + '% ' + (f.y * 100) + '%';
    img.style.transform = 'scale(' + ZOOM + ')';
    zoomed = true;
    img.classList.add('is-zoomed');
  }
  /* pans are batched to the compositor's own beat — one style write per
     frame no matter how fast the pointer reports (120Hz+ trackpads) */
  var panRaf = 0, panX = 0, panY = 0;
  function panTo(cx, cy) {
    panX = cx; panY = cy;
    if (panRaf) return;
    panRaf = requestAnimationFrame(function () {
      panRaf = 0;
      var f = frac(panX, panY);
      img.style.transformOrigin = (f.x * 100) + '% ' + (f.y * 100) + '%';
    });
  }

  function show(i) {
    idx = (i % N + N) % N;
    zoomOut();
    fitRect = null;
    img.src = items[idx].src;
    img.alt = items[idx].alt;
    count.textContent = pad(idx + 1) + ' / ' + pad(N);
  }

  function openAt(i) {
    show(i);
    document.body.classList.add('lb-lock');
    lb.classList.add('is-open');
    open = true;
    if (closeBtn.focus) closeBtn.focus({ preventScroll: true });
  }
  function closeLb() {
    if (!open) return;
    open = false;
    zoomOut();
    lb.classList.remove('is-open');
    document.body.classList.remove('lb-lock');
    /* bring the underlying gallery to the image we ended on */
    if (thumbs[idx] && !thumbs[idx].classList.contains('is-on')) thumbs[idx].click();
  }

  function currentGalleryIndex() {
    for (var i = 0; i < slides.length; i++) if (slides[i].classList.contains('is-active')) return i;
    return 0;
  }

  /* ---- affordance: a zoom chip on the stage + click the live photo ---- */
  var chip = document.createElement('button');
  chip.className = 'gal-zoom';
  chip.type = 'button';
  chip.setAttribute('aria-label', 'Expand image');
  chip.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3M11 8v6M8 11h6"/></svg>';
  chip.addEventListener('click', function (e) { e.stopPropagation(); openAt(currentGalleryIndex()); });
  stage.appendChild(chip);

  stage.addEventListener('click', function (e) {
    var im = e.target.closest ? e.target.closest('.gal-slide img') : null;
    if (!im) return;
    var slide = im.closest('.gal-slide');
    if (!slide || !slide.classList.contains('is-active')) return;
    openAt(currentGalleryIndex());
  });

  /* ---- controls ---- */
  closeBtn.addEventListener('click', closeLb);
  prevBtn.addEventListener('click', function () { show(idx - 1); });
  nextBtn.addEventListener('click', function () { show(idx + 1); });

  /* click backdrop / letterbox (not the image, not a control) closes */
  lb.addEventListener('click', function (e) {
    if (e.target === lb || e.target === lbStage) closeLb();
  });

  /* zoom + pan */
  img.addEventListener('pointerdown', function (e) {
    down = true; dragged = false; downX = e.clientX; downY = e.clientY;
  });
  lbStage.addEventListener('pointermove', function (e) {
    if (down && (Math.abs(e.clientX - downX) > 6 || Math.abs(e.clientY - downY) > 6)) dragged = true;
    if (zoomed) { panTo(e.clientX, e.clientY); if (e.pointerType !== 'mouse') e.preventDefault(); }
  }, { passive: false });
  window.addEventListener('pointerup', function () { down = false; });
  img.addEventListener('click', function (e) {
    e.stopPropagation();
    if (dragged) { dragged = false; return; }   /* a pan, not a toggle */
    if (zoomed) zoomOut(); else zoomInAt(e.clientX, e.clientY);
  });

  img.addEventListener('load', function () { fitRect = null; });
  window.addEventListener('resize', function () { if (open) { zoomOut(); fitRect = null; } });

  /* keyboard — capture so it never leaks to the page's gallery/back handlers */
  window.addEventListener('keydown', function (e) {
    if (!open) return;
    if (e.key === 'Escape') { e.preventDefault(); e.stopImmediatePropagation(); closeLb(); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); e.stopImmediatePropagation(); show(idx + 1); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); e.stopImmediatePropagation(); show(idx - 1); }
  }, true);
})();
